




































































































































































































































import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import {State, Action, Mutation} from 'vuex-class'
import Pagination from '@/modules/core/model/pagination'
import Reservation from '@/modules/reservation/model/Reservation'
import { PaginationInput } from '@/modules/core/model/pagination'
import ReservationDetail from '@/modules/reservation/components/ReservationDetail.vue'
import ReservationListFilters from '@/modules/reservation/components/ReservationListFilters.vue'
import {Watch} from 'vue-property-decorator'
import {VDataTableOptions, VDataTablePagination} from '@/types'
import {ReservationPaginationFilters} from '@/modules/reservation/api'
import DeleteReservationConfirm from '@/modules/reservation/components/DeleteReservationConfirm.vue'
import {notify} from '@/modules/core/notification';
import PrintReservation from "@/modules/reservation/components/PrintReservation.vue";

/**
 * Lista de reservas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        PrintReservation,
        DeleteReservationConfirm,
        ReservationListFilters,
        ReservationDetail,
    },
})
export default class ReservationList extends Vue {

    /**
     * Carga una paginación de reservas en base a los filtros argumentados
     */
    @Action('reservation/loadReservationPagination')
    public loadPagination: () => void

    /**
     * Paginación actualmente cargada
     */
    @State(state => state.reservation.reservationPagination)
    public pagination: Pagination<Reservation>

    @State(state => state.reservation.loadingReservationPagination)
    public loading: boolean

    /**
     * ´Datos de entrada de la paginación actualmente usados
     */
    @State(state => state.reservation.reservationPaginationInput)
    public paginationInput: PaginationInput<ReservationPaginationFilters>

    /**
     * Establece la información para solicitar una paginación que será utilizada si se invoca
     * la acción loadReservationPagination
     */
    @Mutation('reservation/SET_RESERVATION_PAGINATION_INPUT')
    public setReservationPaginationInput: (input: PaginationInput<ReservationPaginationFilters>) => void

    /**
     * Establece la reserva actualmente seleccionada por el usuario
     */
    @Mutation('reservation/SET_CURRENT_RESERVATION')
    public setCurrentReservation: (reservation: Reservation) => void

    public selected = []

    public selectComparator = (select: Reservation, value: Reservation) => {
        return select.id === value.id
    }

    public selectedFields = ['id', 'dateStart', 'dateEnd', 'department.id', 'user.id', 'operator.id', 'actions']

    /**
     * Comprueba si un campo se encuentra activo
     */
    public fieldIsActive (field: string) {
        return !!this.selectedFields.find(f => f === field)
    }

    /**
     * Cabeceras de la tabla de reservas
     */
    public get headers () {
        return this.availableFields.filter(field => this.fieldIsActive(field.value))
    }

    /**
     * Lista de campos disponibles para mostrar en la tabla
     */
    public availableFields = [
        {
            text: 'ID',
            value: 'id',
            description: 'Identificador de la reserva',
        },
        {
            text: 'Fecha de inicio',
            value: 'dateStart',
            description: 'Fecha y hora de comienzo de la reserva',
        },
        {
            text: 'Fin de fin',
            value: 'dateEnd',
            description: 'Fecha y hora de fin de la reserva',
        },
        {
            text: 'Departamento',
            value: 'department.id',
            sortable: false,
            description: 'Departamento donde se realizó la reserva',
        },
        {
            text: 'A nombre de',
            value: 'user.id',
            sortable: false,
            description: 'Usuario que hara uso del departamento reservado',
        },
        {
            text: 'Reservada por',
            value: 'operator.id',
            sortable: false,
            description: 'Usuario que realizo la reserva',
        },
        {
            text: 'Evento',
            value: 'event.id',
            sortable: false,
            description: 'Nombre del evento asociado',
        },
        {
            text: 'ID documento',
            value: 'documentID',
            sortable: false,
            description: 'Número de factura o ticker generado al realizar la reserva',
        },
        {
            text: 'Pago',
            value: 'payment.id',
            sortable: false,
            description: 'Número de pago online generado (si el usuario pagó online)',
        },
        {
            text: 'Acciones',
            sortable: false,
            value: 'actions',
            align: 'center',
            width: '120px',
        },
    ]

    public detail = false
    public tableOptions: Partial<VDataTableOptions> = {
        page: 1,
        sortBy: ['id'],
        sortDesc: [true],
    }

    public deleteConfirm = false
    public filter = false
    public multiDelete = false
    public multiDeleting = false
    public fieldConfiguration = false

    public get noDataText () {
        return this.loading ? 'Cargando resultados...' : 'No se han encontrado resultados'
    }

    public get styles () {
        return {
            height: this.loading ? '100px' : '100%',
        }
    }

    /**
     * Observa los cambios de la paginación de la table y solicita la información
     * al servidor
     */
    @Watch('tableOptions', {deep: true})
    public async watchTablePagination (options: VDataTableOptions) {
        const input = _.cloneDeep(this.paginationInput)
        input.page = options.page
        input.recordsPerPage = options.itemsPerPage
        input.orderBy = {
            field: options.sortBy[0] || 'id',
            direction: (options.sortDesc[0] || false) ? 'DESC' : 'ASC',
        }

        this.$vuetify.goTo(0)
        this.setReservationPaginationInput(input)
        await this.loadPagination()
        this.selected = []
    }

    /**
     * Observa los campos seleccionados por el usuario y cuando estos cambian
     * son almacenados en localStorage para mantener la configuración
     * del usuario
     */
    @Watch('selectedFields')
    public watchSelectedField (value: string[]) {
        localStorage.setItem(
            'config.reservations.list.selectedFields',
            JSON.stringify(value),
        )
    }

    /**
     * Carga la lista de campos seleccionados por el usuario almacenados en localStorage
     */
    public loadSelectedFields () {
        const fields = JSON.parse(
            localStorage.getItem('config.reservations.list.selectedFields') || '[]',
        )

        if (!Array.isArray(fields) || !fields.length) {
            return
        }

        this.selectedFields = fields
    }

    /**
     * Seleccionada una reserva para eliminar y activa la pantalla de confirmación de borrado
     */
    public removeReservation (reservation: Reservation) {
        this.setCurrentReservation(reservation)
        this.deleteConfirm = true
    }

    /**
     * Convierte un objeto de fecha en una cadena de texto legible por el usuario
     *
     * @param date
     */
    public fancyDate (date: Date, format = 'DD/MM/YYYY HH:mm'): string {
        return moment(date).format(format)
    }

    public get isLargeScreen () {
        return this.$vuetify.breakpoint.xl
    }

    /**
     * Al crear el componente carga la primera paginación de reservas
     */
    public async created () {
        this.loadSelectedFields()
        await this.loadPagination()
    }

    public async remove () {
        if (!this.selected.length) {
            return
        }

        this.multiDeleting = true

        const count: number = await this.$store.dispatch(
            'reservation/deleteReservationList',
            this.selected,
        )

        notify(`Se han eliminado ${count} reservas`)
        this.multiDeleting = false
        this.multiDelete = false

        await this.loadPagination()
        this.selected = []
    }
}
